import * as Util from '../../common/js/util'

const SHOW_MENU = true
const HIDE_MENU = false

const menulist = {
  state: {
    isShow: false,
    menuListDefault: {
      title: 'title : by 把苹果咬哭',
      content: {
        download: {
          id: 1,
          name: '下载',
          type: 'router',
          action: 'download'
        },
        preview: {
          id: 2,
          name: '预览',
          type: 'router',
          action: 'preview'
        },
        delivery: {
          id: 3,
          name: '外链分享',
          type: 'router',
          action: 'delivery'
        },
        cancelDelivery: {
          id: 4,
          name: '取消外链',
          type: 'router',
          action: 'cancelDelivery'
        },
        favorite: {
          id: 5,
          name: '收藏',
          type: 'router',
          action: 'favorite'
        },
        cancelFavorite: {
          id: 6,
          name: '取消收藏',
          type: 'router',
          action: 'cancelFavorite'
        },
        comment: {
          id: 7,
          name: '评论',
          type: 'router',
          action: 'comment'
        },
        move: {
          id: 8,
          name: '移动',
          type: 'router',
          action: 'move'
        },
        copy: {
          id: 9,
          name: '复制',
          type: 'router',
          action: 'copy'
        },
        rename: {
          id: 10,
          name: '重命名',
          type: 'router',
          action: 'rename'
        },
        detail: {
          id: 11,
          name: '详情',
          type: 'router',
          action: 'detail'
        },
        history: {
          id: 12,
          name: '历史版本',
          type: 'router',
          action: 'history'
        },
        delete: {
          id: 13,
          name: '删除',
          type: 'router',
          color: '#FE3824',
          action: 'delete'
        }
      }
    },
    menuList: {
      title: '',
      content: []
    }
  },
  mutations: {
    showMenu (state, fileInfo) {
      var compare = function (prop) {
        return function (obj1, obj2) {
          var val1 = obj1[prop]
          var val2 = obj2[prop]
          if (val1 < val2) {
            return -1
          } else if (val1 > val2) {
            return 1
          } else {
            return 0
          }
        }
      }

      state.menuList.title = fileInfo.currentFile.name
      state.menuList.content = []
      var auth = Util.getCSSActionByCode(fileInfo.currentFile.access_mode).authCSS.split(':')
      for (var o in auth) {
        if (state.menuListDefault.content[auth[o]]) {
          // GY,BUG40747,选择团队文件夹，更多菜单里不应该显示重命名、移动和删除按钮
          if (fileInfo.currentFile.is_team && fileInfo.currentFile.is_dir && auth[o] === 'rename') {
            continue
          }
          if (fileInfo.currentFile.is_team && fileInfo.currentFile.is_dir && auth[o] === 'move') {
            continue
          }
          if (fileInfo.currentFile.is_team && fileInfo.currentFile.is_dir && auth[o] === 'delete') {
            continue
          }
          if (!Util.canPreview(fileInfo.currentFile.mime_type) && auth[o] === 'preview') {
            continue
          }
          // 如果是文件夹则不显示下载按钮
          if (fileInfo.currentFile.is_dir && auth[o] === 'download') {
            continue
          }
          if (fileInfo.currentFile.is_dir && auth[o] === 'comment') {
            continue
          }
          // 共享根目录下不支持重命名
          if ((fileInfo.currentFolder.path_type === 'share_in' || fileInfo.currentFolder.path_type === 'share_out') && fileInfo.currentFolder.path === '/' && auth[o] === 'rename') {
            continue
          }
          if (fileInfo.currentFile.is_dir && fileInfo.currentFolder.path_type === 'favorite' && fileInfo.currentFolder.path === '/' && (auth[o] === 'rename' || auth[o] === 'delete')) {
            continue
          }
          if (!fileInfo.currentFile.is_dir && fileInfo.currentFolder.path_type === 'favorite' && fileInfo.currentFolder.path === '/' && (auth[o] === 'rename' || auth[o] === 'delete' || auth[o] === 'move' || auth[o] === 'copy' || auth[o] === 'comment')) {
            continue
          }
          state.menuList.content.push(state.menuListDefault.content[auth[o]])
        }
      }
      if (!fileInfo.currentFile.is_dir) {
        state.menuList.content.push(state.menuListDefault.content['history'])
      }
      // 外链code不为空 添加取消外链功能
      if (fileInfo.currentFile.delivery_code !== '') {
        state.menuListDefault.content.delivery.name = '查看外链'
        state.menuList.content.push(state.menuListDefault.content['cancelDelivery'])
      } else {
        state.menuListDefault.content.delivery.name = '外链分享'
      }
      // 文件已经收藏，添加取消收藏功能
      if (fileInfo.currentFile.is_bookmark === true || fileInfo.currentFolder.path_type === 'favorite') {
        state.menuListDefault.content.favorite.name = '取消收藏'
        state.menuList.content.push(state.menuListDefault.content['cancelFavorite'])
      } else {
        state.menuListDefault.content.favorite.name = '收藏'
        state.menuList.content.push(state.menuListDefault.content['favorite'])
      }
      state.menuList.content.push(state.menuListDefault.content['detail'])
      state.menuList.content.sort(compare('id'))
      state.isShow = SHOW_MENU
    },
    hideMenu (state) {
      // state.detail = {}
      state.isShow = HIDE_MENU
    }
  },
  actions: {
    showMenuList ({commit, rootState}, obj) {
      commit('showMenu', rootState.fileInfo)
    },
    hideMenuList ({commit}) {
      commit('hideMenu')
    }
  },
  getters: {
    getIsShow: state => state.isShow,
    getShowMenuList: state => state.menuList
  }
}
export default menulist



// WEBPACK FOOTER //
// ./src/store/modules/currentSeletctFileMenu.js